type ImageServerImgFormat =
  | 'jpgpng'
  | 'png'
  | 'png24'
  | 'png32'
  | 'jpg'
  | 'tiff'
  | 'gif'
  | 'lerc'
  | 'png8'
  | 'bmp'
  | undefined;

export const LAYER_IDS = {
  FOREST_PRESENCE: 'forest-presence-layer',
  REFERENCE_DATA: 'reference-data-layer',
  GENUS_DISTRIBUTION: 'genus-distribution-layer',
  GENUS_RANGE: 'genus-range-feature-layer',
  WORLD_COUNTRIES: 'world-countries-layer',
};

export const LAYERS_CONFIG = {
  FOREST_PRESENCE: {
    url: 'https://ic.imagery1.arcgis.com/arcgis/rest/services/Sentinel2_10m_LandCover/ImageServer',
    title: 'Forest presence layer',
    id: 'forest-presence-layer',
    format: 'jpgpng' as ImageServerImgFormat,
  },
  REFERENCE_DATA: {
    url: 'https://services2.arcgis.com/HlCEjEqEP9GdOQeZ/arcgis/rest/services/reference_data_updated/FeatureServer/0',
    title: 'Reference data layer',
    id: 'reference-data-layer',
  },
  GENUS_DISTRIBUTION: {
    url: (genusName: string) =>
      `https://services2.arcgis.com/HlCEjEqEP9GdOQeZ/arcgis/rest/services/${genusName}_clipped/FeatureServer/0`,
    title: 'Genus distribution',
    id: 'genus-distribution-layer',
  },
  GENUS_RANGE: {
    url: (genusName: string) =>
      `https://services2.arcgis.com/HlCEjEqEP9GdOQeZ/arcgis/rest/services/${genusName}_distribution_and_buffer_clipped/FeatureServer/0`,
    title: 'Reference data (Area of Insight)',
    id: 'genus-range-feature-layer',
  },

  WORLD_COUNTRIES: {
    url: 'https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/World_Countries_(Generalized)/FeatureServer/0',
    title: 'World countries',
    id: 'world-countries-layer',
  },
};
